import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Booking from "../pages/booking/page";
import Impressum from "../pages/impressum/page";
import Datenschutz from "../pages/datenschutz/page";
import AGB from "../pages/agb/page";
import About from "../pages/about/page";
import Danke from "../pages/danke/page";
import WebsiteImpact from "../pages/website-impact/page";
import FAQ from "../pages/faq/page";
import Hotels from "../pages/hotels/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/termin-buchen",
    element: <Booking />,
  },
  {
    path: "/ueber-uns",
    element: <About />,
  },
  {
    path: "/website-wirkung",
    element: <WebsiteImpact />,
  },
  {
    path: "/hotels",
    element: <Hotels />,
  },
  {
    path: "/danke",
    element: <Danke />,
  },
  {
    path: "/impressum",
    element: <Impressum />,
  },
  {
    path: "/datenschutz",
    element: <Datenschutz />,
  },
  {
    path: "/agb",
    element: <AGB />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
